import { render } from "./LessonCreationForm.vue?vue&type=template&id=49aa0536&scoped=true"
import script from "./LessonCreationForm.vue?vue&type=script&lang=js"
export * from "./LessonCreationForm.vue?vue&type=script&lang=js"

import "./LessonCreationForm.vue?vue&type=style&index=0&id=49aa0536&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49aa0536"]])

export default __exports__